<app-loader></app-loader>
<app-application-dialog
	*ngIf="isAppDisplayed"
	[application]="appDisplayed"
	(onCloseRequested)="closeFrame()"
></app-application-dialog>
<mat-sidenav-container>
	<!-- FIN MODULARIZACION -->
	<mat-sidenav #sidenav mode="side" position="end" [(opened)]="opened" opened>
		<!-- MODULARIZAR POR FAVOR -->
		<div class="container">
			<div class="row profile">
				<div class="buttons-main-container">
					<div
						[ngClass]="
							userProfile.darkPercentage > 0.5
								? 'close-icon-white'
								: 'close-icon'
						"
						class="header-icon"
						(click)="toggle()"
					></div>
				</div>
				<div class="col-md-12">
					<div class="profile-sidebar">
						<!-- SIDEBAR USERPIC -->
						<div
							class="profile-userpic text-center"
							(click)="toggle()"
						>
							<img
								[src]="photo"
								class="img-responsive"
								alt=""
								(click)="traceUserData()"
							/>
						</div>
						<!-- END SIDEBAR USERPIC -->
						<!-- SIDEBAR USER TITLE -->
						<div class="profile-usertitle">
							<div class="profile-usertitle-name">
								{{ userProfile?.name }}
							</div>
							<div
								class="profile-usertitle-mail"
								title="{{ userProfile?.username }}"
							>
								{{
									userProfile?.username.length > 30
										? userProfile?.username.substring(
												0,
												27
											) + "..."
										: userProfile?.username
								}}
							</div>
							<div
								class="profile-usertitle-job"
								style="display: none"
							>
								<h6 class="panel-title">
									{{
										"header.toolbar.userPanel.role"
											| translate
									}}
								</h6>
								<ul>
									<li
										*ngFor="
											let rol of userProfile?.profiles
										"
										title="{{ rol.profile }}"
									>
										{{ rol.profile }}
									</li>
								</ul>
							</div>
						</div>
						<!-- END SIDEBAR USER TITLE -->
						<!-- SETTINGS OPTIONS -->
						<h6 class="panel-title">
							{{
								"header.toolbar.userPanel.settings" | translate
							}}
						</h6>
						<section class="dark-mode" style="display: none">
							<mat-slide-toggle
								[checked]="darkMode"
								(change)="changeDarkModeStatus($event)"
							>
								{{
									"header.toolbar.userPanel.darkMode"
										| translate
								}}
							</mat-slide-toggle>
							<!-- <mat-slider [min]="0" [max]="2" [step]="1" (change)="qualitySlider($event)"></mat-slider> -->
						</section>
						<section *ngIf="!darkMode" class="dark-slider">
							<mat-slider
								[(ngModel)]="percentage"
								(valueChange)="refreshStyles(+$event)"
								min="0"
								max="1"
								step="0.01"
							>
								<input matSliderThumb />
							</mat-slider>
						</section>
						<section class="optimized-mode" style="display: none">
							<mat-slide-toggle
								[checked]="optimized"
								(change)="changeOptimizedStatus($event)"
							>
								{{
									"header.toolbar.userPanel.optimizedMode"
										| translate
								}}
							</mat-slide-toggle>
							<!-- <mat-slider [min]="0" [max]="2" [step]="1" (change)="qualitySlider($event)"></mat-slider> -->
						</section>
						<mat-select
							class="languageSelect"
							[(value)]="langSelected"
							(selectionChange)="changeLanguage($event)"
						>
							<mat-select-trigger>
								<span
									class="flag-icon flag-icon-{{
										dictionary[langSelected]
									}}"
								>
									<p class="language-title">
										{{
											"languages." + langSelected
												| translate
										}}
									</p>
								</span>
							</mat-select-trigger>
							<mat-option
								*ngFor="let item of dictionary | keyvalue"
								value="{{ item.key }}"
							>
								<span
									class="flag-icon flag-icon-{{ item.value }}"
								>
									<p class="language-title">
										{{
											"languages." + item.key | translate
										}}
									</p>
								</span>
							</mat-option>
						</mat-select>
						<!-- Admin ref -->
						<br />
						<div
							class="admin-portal profile-userbuttons"
							*ngIf="isAdmin"
						>
							<a
								class="nav-link display-inline-block"
								(click)="goToAdmin()"
								>{{
									"header.toolbar.userPanel.admin" | translate
								}}</a
							>
						</div>
						<!-- EVO00003: Carga Usuarios y Finance Data ocultados del menú lateral -->
						<!-- Los handlers onUploadUserDataFiles/onUploadFinanceDataFiles se mantienen en el componente -->
						<!-- END MENU -->
					</div>
				</div>
			</div>
		</div>
	</mat-sidenav>
	<mat-sidenav-content>
		<app-header (toggleProfile)="toggle()"></app-header>
		<router-outlet></router-outlet>
	</mat-sidenav-content>
</mat-sidenav-container>
